// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false
// };

// import packageInfo from './package.json';

export const environment = {
  // appVersion: packageInfo.version,
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyCz7d_sQb9bcgmB2fCx1nHkdxPmvAgRIwk",
    authDomain: "wasla-llc-7cceb.firebaseapp.com",
    projectId: "wasla-llc-7cceb",
    storageBucket: "wasla-llc-7cceb.firebasestorage.app",
    messagingSenderId: "444487197556",
    appId: "1:444487197556:web:6d6cb06654469d803e8221",
    measurementId: "G-0MXLQVV43H"
  }
};

export const environment2 = {
    production: true,
    backend: {
        baseURL: "/api/"
    }
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
